
































	import Vue from 'vue';
    import _users from '../../services/endpoints/users';

    export default Vue.extend({
        name: "PasswordForgotDialog",
        props: ['open'],
        data: () => ({
            accname: '',
            accNameRules: [
                (v: string) => !!v || 'Bitte gib deinen Accountnamen an',
                (v: string) => /^[a-zA-Z\s]+\.\d{4}$/.test(v) || 'Bitte gib einen gültigen Accountnamen an',
            ],
            buttonText: 'E-Mail senden',
            buttonClicked: false,
        }),
        computed: {
            openComputed: {
                get: function(): boolean {
                    return this.open;
                },
                set: function(): void {
                    this.$emit('close');
                }
            }
        },
        methods: {
            resetPassword: async function(): Promise<void> {
                if (!this.buttonClicked) {
                    this.buttonClicked = true;
                    if (/^[a-zA-Z\s]+\.\d{4}$/.test(this.accname)) {
                        await _users.createResetToken(this.accname);
                        this.$emit('close');
                        this.buttonClicked = false;
                    } else {
                        this.buttonClicked = false;
                    }
                }
            }
        }
    })
